import * as designTokens from './shadow';

export const shadows = {
  ...designTokens,
};
